if (!customElements.get('quick-add-bulk')) {
  customElements.define(
    'quick-add-bulk',
    class QuickAddBulk extends BulkAdd {
      constructor() {
        super();
        this.quantity = this.querySelector('quantity-input');

        const debouncedOnChange = debounce((event) => {
          if (parseInt(event.target.value) === 0) {
            this.startQueue(event.target.dataset.index, parseInt(event.target.value));
          } else {
            this.validateQuantity(event);
          }
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener('change', debouncedOnChange.bind(this));
        this.listenForActiveInput();
        this.listenForKeydown();
        this.lastActiveInputId = null;
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (
            event.source === 'quick-add' ||
            (event.cartData.items && !event.cartData.items.some((item) => item.id === parseInt(this.dataset.index))) ||
            (event.cartData.variant_id && !(event.cartData.variant_id === parseInt(this.dataset.index)))
          ) {
            return;
          }
          // If its another section that made the update
          this.onCartUpdate().then(() => {
            this.listenForActiveInput();
            this.listenForKeydown();
          });
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      get input() {
        return this.querySelector('quantity-input input');
      }

      selectProgressBar() {
        return this.querySelector('.progress-bar-container');
      }

      listenForActiveInput() {
        if (!this.classList.contains('hidden')) {
          this.input?.addEventListener('focusin', (event) => event.target.select());
        }
        this.isEnterPressed = false;
      }

      listenForKeydown() {
        this.input?.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            this.input?.blur();
            this.isEnterPressed = true;
          }
        });
      }

      cleanErrorMessageOnType(event) {
        event.target.addEventListener(
          'keypress',
          () => {
            event.target.setCustomValidity('');
          },
          { once: true }
        );
      }

      get sectionId() {
        if (!this._sectionId) {
          this._sectionId = this.closest('.collection-quick-add-bulk').dataset.id;
        }

        return this._sectionId;
      }

      onCartUpdate() {
        return new Promise((resolve, reject) => {
          fetch(`${this.getSectionsUrl()}?section_id=${this.sectionId}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const sourceQty = html.querySelector(`#quick-add-bulk-${this.dataset.index}-${this.sectionId}`);
              if (sourceQty) {
                this.innerHTML = sourceQty.innerHTML;
              }
              resolve();
            })
            .catch((e) => {
              console.error(e);
              reject(e);
            });
        });
      }

      getSectionsUrl() {
        const pageParams = new URLSearchParams(window.location.search);
        const pageNumber = decodeURIComponent(pageParams.get('page') || '');

        return `${window.location.pathname}${pageNumber ? `?page=${pageNumber}` : ''}`;
      }

      async updateMultipleQty(items) {
        this.selectProgressBar()?.classList.remove('hidden');

        try {
          // Get current cart
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          const validation = await validateOrderGroup(this.dataset.orderGroup);

          if (!validation.success) {

              showOrderGroupPopup(validation.cartOrderGroup);

              this.selectProgressBar()?.classList.add('hidden');
              this.setRequestStarted(false);

              return;
          }
          console.log("Quick Add Dataset:", this.dataset);
          console.log("Current Order Group:", this.dataset.orderGroup);
          const requests = [];

          for (const [id, desiredQty] of Object.entries(items)) {
            const variantId = parseInt(id);
            const targetQty = parseInt(desiredQty);

            // Current quantity in cart
              const existingItem = cart.items.find(
              (item) => item.variant_id === variantId
            );

            const currentQty = existingItem ? existingItem.quantity : 0;
            const difference = targetQty - currentQty;

            // Add only the difference
            if (difference > 0) {
              requests.push(
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                  },
                  body: JSON.stringify({
                  items: [
                    {
                      id: variantId,
                      quantity: difference,
                      properties: {
                        order_group: this.dataset.orderGroup
                      }
                    },
                  ],
                })
                })
              );
            }

            // Reduce quantity
            if (difference < 0 && existingItem) {
              requests.push(
                fetch('/cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                  },
                  body: JSON.stringify({
                    id: existingItem.key,
                    quantity: targetQty,
                  }),
                })
              );
            }
          }

          await Promise.all(requests);

          const updatedCart = await fetch('/cart.js').then((r) => r.json());

          this.queue = [];

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'quick-add',
            cartData: updatedCart,
          });

          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
            })
          );
        } catch (error) {
          console.error('Bulk Add Error:', error);
        } finally {
          this.selectProgressBar()?.classList.add('hidden');
          this.setRequestStarted(false);
        }
      }

      getSectionsToRender() {
        return [
          {
            id: `quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
            section: this.sectionId,
            selector: `#quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'CartDrawer',
            selector: '.drawer__inner',
            section: 'cart-drawer',
          },
        ];
      }



      
      renderSections(parsedState, ids) {
        const intersection = this.queue.filter((element) => ids.includes(element.id));
        if (intersection.length !== 0) return;
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);
          if (section.section === 'cart-drawer') {
            sectionElement.closest('cart-drawer')?.classList.toggle('is-empty', parsedState.items.length === 0);
          }
          const elementToReplace =
            sectionElement && sectionElement.querySelector(section.selector)
              ? sectionElement.querySelector(section.selector)
              : sectionElement;
          if (elementToReplace) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        if (this.isEnterPressed) {
          this.querySelector(`#Quantity-${this.lastActiveInputId}`).select();
        }

        this.listenForActiveInput();
        this.listenForKeydown();
      }
    }
  );
}
document.addEventListener('DOMContentLoaded', () => {

  const buttons = document.querySelectorAll('.single-variant-add');

  async function syncButtonsWithCart() {

    try {

      const response = await fetch('/cart.js');
      const cart = await response.json();

      const cartVariantIds = cart.items.map(item => item.variant_id);

      buttons.forEach((button) => {

        const variantId = parseInt(button.dataset.variantId);

        if (cartVariantIds.includes(variantId)) {

          button.disabled = true;
          button.textContent = 'Added';

        } else {

          button.disabled = false;
          button.textContent = 'Add to Cart';
        }
      });

    } catch (error) {

      console.error('Cart Sync Error:', error);
    }
  }

  buttons.forEach((button) => {

   button.addEventListener('click', async () => {

    const variantId = parseInt(button.dataset.variantId);

    if (!variantId) return;

    button.disabled = true;
    button.textContent = 'Adding...';

    try {

      const validation = await validateOrderGroup(button.dataset.orderGroup);

      if (!validation.success) {

        showOrderGroupPopup(validation.cartOrderGroup);

        button.disabled = false;
        button.textContent = 'Add to Cart';

        return;

      }

      const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: {
                  order_group: button.dataset.orderGroup
                }
              }
            ]
          })
        });

        if (!response.ok) {
          throw new Error('Add to cart failed');
        }

        button.textContent = 'Added';

        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true
          })
        );

        syncButtonsWithCart();

      } catch (error) {

        console.error(error);

        button.disabled = false;
        button.textContent = 'Add to Cart';
      }
    });
  });

  syncButtonsWithCart();

  document.addEventListener('cart:refresh', () => {
    syncButtonsWithCart();
  });

});
